export default __webpack_public_path__ + "SMO-Welcome.eacf98db49a78ece3630d891ca3d7af0.svg";